// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__a5_pJ","top":"styles_top__3ALBY"};